import { render, staticRenderFns } from "./DashboardConversations.vue?vue&type=template&id=a9fcff4c&"
import script from "./DashboardConversations.vue?vue&type=script&lang=js&"
export * from "./DashboardConversations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports